import { faBell } from '@fortawesome/pro-duotone-svg-icons';

import { usePreferencesContext } from 'lib/common/contexts/PreferencesContext';

import Checkbox from 'lib/common/components/atoms/Checkbox';
import PreferenceSectionContainer from 'lib/common/components/molecules/Preferences/components/PreferenceSectionContainer';

const PreferencesGeneral = () => {
  const {
    state: { incomingChatNotificationsEnabled },
    actions: { setIncomingChatNotificationsEnabled },
  } = usePreferencesContext();

  return (
    <PreferenceSectionContainer icon={faBell} title={'Notifications'}>
      <Checkbox
        id="incoming-chat-notifications-checkbox"
        label="Chat message notifications"
        checked={incomingChatNotificationsEnabled}
        reverse
        onChange={setIncomingChatNotificationsEnabled}
      />
    </PreferenceSectionContainer>
  );
};

export default PreferencesGeneral;
